import React, { useState, useEffect } from "react";
import Select from 'react-select';
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const TicketProductList = ({ cart, setCart }) => {
    const [clientId, setSelectedClient] = useState(null);
    const [description, setDesc] = useState("");
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [msg, setMsg] = useState("");
    const navigate = useNavigate();
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_KEY = process.env.REACT_APP_API_KEY;

    const handleRemove = (id) => {
      //  console.log(id);
        const arr = cart.filter((item) => item.uuid !== id);
       // console.log(arr);
        setCart(arr);
    };

    useEffect(() => {
        const fetchOptions = async () => {
          setIsLoading(true);
          try {
            // Replace with your actual Node.js API endpoint
            const result = await axios.get(`${API_BASE_URL}/client`, {
              headers: {
                'X-API-Key': API_KEY
              },
            }); 
            const data = result.data;

            // Map the API data to the format react-select expects: { value: '', label: '' }
            const formattedOptions = data.map(itemselect => ({
              value: itemselect.id,
              label: itemselect.name+" - "+itemselect.address+" - "+itemselect.email,
            }));

            setOptions(formattedOptions);
            setError(null);
          } catch (err) {
            setError('Failed to load options');
            console.error(err);
          } finally {
            setIsLoading(false);
          }
        };

      fetchOptions();
    }, []);

    const handleClientChange = (selectedOption) => {
      setSelectedClient(selectedOption);
      console.log('Option selected:', selectedOption);
    };

    const saveTicket = async (e) => {
      e.preventDefault();    
      try {
        await axios.post(`${API_BASE_URL}/mytickets`, {
            headers: {
              'X-API-Key': API_KEY
            },
            description: description,
            clientId: clientId.value,
            cart
        });
        navigate("/mytickets");
      } catch (error) {
        if (error.response) {
          setMsg(error.response.data.msg);
        }
      }
    };

  return (
    <div className="container">
        <div className="columns">
            <div className="column is-centered">
                <h1 className="title has-text-centered is-size-5">FORM TICKET</h1>
                 {error && <p style={{ color: 'red' }}>{error}</p>}
                <div className="card is-shadowless">
                    <table className="table is-bordered is-striped is-fullwidth is-size-6">
                        <thead>
                            <tr>
                                <th style={{width: "1%"}}>No</th>
                                <th className="has-text-centered" style={{width: "5%"}}>Image</th>
                                <th className="has-text-centered" style={{width: "30%"}}>Product_Name</th>
                                <th className="has-text-centered">Serial_Number</th>
                                <th className="has-text-centered">Merek/Manufakturer</th>
                                <th className="has-text-centered">Qty</th>
                                <th className="has-text-centered">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cart.map((item, index) => (
                                <tr key={item.uuid}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <figure className="image is-48x48">
                                            <img src={item.url} alt="Image" />
                                        </figure>
                                    </td>
                                    <td>{item.name}</td>
                                    <td className="has-text-centered">{item.serialnumber}</td>
                                    <td className="has-text-centered">{item.manufacturer}</td>                
                                    <td className="has-text-centered">{item.amount}</td>
                                    <td className="has-text-centered">
                                        <button className="button is-small is-danger" onClick={() => handleRemove(item.uuid)}>Remove</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>                    
                    <form onSubmit={saveTicket}>
                        <p className="has-text-left has-text-danger">{msg}</p>
                        <div className="field">                           
                            <label className="label">Client/Customer</label>
                            {error && <p style={{ color: 'red' }}>{error}</p>}
                            <div className="control">
                                <div className="is-fullwidth">
                                <Select
                                    value={clientId}
                                    onChange={handleClientChange}
                                    options={options}
                                    isLoading={isLoading}
                                    isClearable={true} 
                                    placeholder="Search Client/Customer..."
                                    required
                                    />
                                </div>
                            </div>                         
                        </div>
                        <div className="field">
                            <label className="label">Problem_Description</label>
                            <div className="control">
                                <textarea
                                    className="textarea"
                                    value={description}
                                    onChange={(e) => setDesc(e.target.value)}
                                    placeholder="Problem Description"
                                    rows="4"
                                    required
                                ></textarea>
                            </div>
                        </div>
                        <div className="field">
                            <Link to="/mytickets">
                            <button className="button is-warning mr-1">
                                Cancel
                            </button>
                            </Link>
                            <button type="submit" className="button is-success">
                                Save
                            </button>
                        </div>          
                    </form>
                </div>
            </div>
        </div>
    </div>
  );
};

export default TicketProductList;